<template>
  <v-list class="card-analytics-v3">
    <v-list-item class="ps-3">
      <p class="body-bold-medium neutral-20-dark--text mb-0">
        {{ $t('message.pages.analyticsV3.resume.moreMetrics') }}
      </p>
    </v-list-item>

    <v-list-item @click="handleClick('AnalyticsV3Plays')" class="px-3">
      <v-list-item-title class="body-regular-small">
        {{ $t('message.pages.analyticsV3.plays') }}
      </v-list-item-title>
      <v-icon size="20">mdi-arrow-right</v-icon>
    </v-list-item>

    <v-divider />

    <v-list-item @click="handleClick('AnalyticsV3Bandwidth')" class="px-3">
      <v-list-item-title class="body-regular-small">
        {{ $t('message.pages.analyticsV3.screen_bandwidth.title') }}
      </v-list-item-title>
      <v-icon size="20">mdi-arrow-right</v-icon>
    </v-list-item>

    <v-divider />

    <v-list-item @click="handleClick('AnalyticsV3Users')" class="px-3">
      <v-list-item-title class="body-regular-small">
        <span class="d-flex align-center">
          {{ $t('message.pages.analyticsV3.users') }}
          <v-tag class="ml-1 px-2">
            {{ $t('message.pages.analyticsV3.resume.new') }}
          </v-tag>
        </span>
      </v-list-item-title>
      <v-icon size="20">mdi-arrow-right</v-icon>
    </v-list-item>

    <v-list-item class="px-3">
      <base-btn
        type="secondary"
        size="small"
        @click="handleClick('AnalyticsV3Plays')"
      >
        {{ $t('message.pages.analyticsV3.resume.viewAll') }}
        <v-icon size="20" class="ml-1">mdi-arrow-right</v-icon>
      </base-btn>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'MoreMetricsMenu',
  methods: {
    handleClick(name) {
      this.$router.push({ name })
    },
  },
}
</script>
